<div class="weekly-work-time-container px-5 pt-3">
    <div class="row">
        <div class="col-12 d-flex" [ngClass]="isWeeklyWorkHoursExceeded() ? 'exceeded-max-hours' : 'header-item'">
            <span class="pb-2" translate="WEEKLY_WORK_TABLE_HEADER_LABEL"></span>
            <span class="ms-auto">: {{ totalDurationOfTheWeek }} </span>
        </div>
    </div>

    <div class="row mb-3">
        <div class="col-12">
            <div
                *ngFor="let days of weeklyWorkTimeList$ | async"
                [ngClass]="{ exceededMaxHours: days.workDuration.asHours() >= maxWorkingHours }"
                class="d-flex pb-1"
            >
                <span> {{ formatDate(days.workDate) }}</span>
                <span class="ms-auto">: {{ days.workDuration.asHours() | formatDuration }} </span>
            </div>
        </div>
    </div>

    <div class="status-bar">
        <div
            [ngClass]="statusBarType"
            class="footer-design d-flex justify-content-center align-items-center position-relative overflow-hidden"
        >
            {{ statusBarText }}
        </div>
    </div>
</div>
